module.exports = __webpack_public_path__ + "static/img/3.5ba206a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/3.png
// module id = hfuT
// module chunks = 0